<template>
    <div class="overflow-auto">
        <Frame />
    </div>
</template>

<script>
import Frame from '@/components/HeartCrush/Frame.vue'
export default {
    components:{
        Frame,
    }
}
</script>

<style>

</style>